import { useField } from 'react-final-form'

export function useFieldValue(name) {
  const {
    input: { value }
  } = useField(name)
  return value
}
